/**
 * Düğme renkleri (mobille aynı): kaydet ve tamamla yeşil, iptal yumuşak
 * kırmızı, silme dolu kırmızı; başlatan düğmeler tema turkuazı.
 */
export const greenButtonSx = (mode) => ({
  bgcolor: mode === "dark" ? "#34B37A" : "#2E9E6A",
  color: "#fff",
  "&:hover": { bgcolor: mode === "dark" ? "#2E9E6A" : "#26885B" },
  "&.Mui-disabled": {
    bgcolor: mode === "dark" ? "rgba(255,255,255,0.1)" : "#E2E8F0",
    color: mode === "dark" ? "rgba(255,255,255,0.45)" : "#6C757D",
  },
});

export const cancelButtonSx = (mode) => ({
  bgcolor: mode === "dark" ? "rgba(242,165,156,0.14)" : "rgba(192,57,43,0.08)",
  color: mode === "dark" ? "#F2A59C" : "#C0392B",
  "&:hover": {
    bgcolor: mode === "dark" ? "rgba(242,165,156,0.22)" : "rgba(192,57,43,0.14)",
  },
});

export const dangerButtonSx = {
  bgcolor: "#C0392B",
  color: "#fff",
  "&:hover": { bgcolor: "#A93226" },
};

/** İnce ilerleme çubuğu: koyuda yarı saydam iz, beyaz dolgu (mobille aynı). */
export const progressSx = (mode) => ({
  backgroundColor: mode === "dark" ? "rgba(255,255,255,0.1)" : "#D6EBEB",
  "& .MuiLinearProgress-bar": {
    backgroundColor: mode === "dark" ? "#FFFFFF" : "#006A71",
    borderRadius: 999,
  },
});
